import { z } from 'zod';

import { questionQuerySchema } from '@/_containers/assessment';
import { practiceExamSchema } from '@/_other-pages/practice-exams/@shared';

export const attemptSchema = practiceExamSchema.extend({
  questions: z.array(
    questionQuerySchema.extend({
      is_correct: z.boolean(),
      selected_answer: z.string(),
      is_submitted: z.boolean(),
      time_spent: z.number(),
    })
  ),
  resumeable_question_index: z.number(),
  last_attempt: z.number(),
  is_completed: z.boolean(),
  progress: z
    .array(
      z.object({
        user_attempt: z.number(),
        total_questions: z.number(),
        answered: z.number(),
        correct: z.number(),
        incorrect: z.number(),
        correct_percent: z.number(),
        incorrect_percent: z.number(),
        progress_percent: z.number(),
        total_time_spent: z.number(),
      })
    )
    .nullable(),
});

export type AttemptSchema = z.infer<typeof attemptSchema>;
